export const config = {
    // Leave this empty because the frontend fetch calls explicitly add '/api'
    // e.g. `${config.backendOrigin}/api/auth/login` becomes `/api/auth/login`.
    backendOrigin: '',
};
